import { useQuery } from "@tanstack/react-query";

import { getSupabaseClient } from "../../providers/supabase/supabase";
import { phone9 } from "./whatsapp";

export const PRIVATE_PHONES_KEY = ["gula-private-phones"];

/** Admins: the numbers whose chats only the admins see. */
export const usePrivatePhones = (enabled: boolean) => {
  const { data } = useQuery({
    queryKey: PRIVATE_PHONES_KEY,
    enabled,
    queryFn: async () => {
      const { data, error } = await getSupabaseClient()
        .from("gula_private_phones")
        .select("phone9");
      if (error) throw error;
      return new Set((data ?? []).map((row) => row.phone9 as string));
    },
  });
  return (phone?: string | null) => {
    const key = phone9(phone);
    return !!key && !!data?.has(key);
  };
};
